import { useEffect, useRef } from "react";

function NewsletterModal({ open, onClose, copy, onSubmit, status }) {
  const dialogRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    inputRef.current?.focus();

    function handleKeyDown(event) {
      if (event.key === "Escape") {
        onClose();
      }
    }

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  function handleBackdropClick(event) {
    if (event.target === event.currentTarget) {
      onClose();
    }
  }

  return (
    <div
      className="newsletter-modal-backdrop"
      onClick={handleBackdropClick}
      role="presentation"
    >
      <div
        className="newsletter-modal"
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="newsletter-modal-title"
      >
        <button
          type="button"
          className="newsletter-modal-close"
          onClick={onClose}
          aria-label={copy.closeLabel}
        >
          ×
        </button>

        <h2 id="newsletter-modal-title" className="newsletter-modal-title">
          {copy.title}
        </h2>
        <p className="newsletter-modal-subtitle">{copy.subtitle}</p>

        {status === "success" ? (
          <p className="newsletter-modal-success" role="status">
            {copy.success}
          </p>
        ) : (
          <form className="newsletter-modal-form" onSubmit={onSubmit}>
            <label className="visually-hidden" htmlFor="newsletter-email">
              {copy.emailLabel}
            </label>
            <input
              id="newsletter-email"
              ref={inputRef}
              type="email"
              name="email"
              required
              autoComplete="email"
              placeholder={copy.emailPlaceholder}
              className="newsletter-modal-input"
              disabled={status === "loading"}
            />
            {status === "error" && (
              <p className="newsletter-modal-error" role="alert">
                {copy.error}
              </p>
            )}
            <button
              type="submit"
              className="newsletter-modal-submit"
              disabled={status === "loading"}
            >
              {status === "loading" ? "..." : copy.submit}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default NewsletterModal;
